import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import RatingComponent from '../../../form/component/RatingComponent'
import { formatDateTime } from '../../../../util/datetime'


const CustomerFeedback = ({ feedbackList }) => {
    if (!feedbackList || feedbackList.length === 0) {
        return null
    }
    return (
        <React.Fragment>
            <Row top="M">
                <Column size={12}>
                    Rating
                </Column>
            </Row>
            {feedbackList.map(({ id, created, score, campaignName, comment }) => {
                return (
                    <Row key={id}>
                        <Column size={2}>
                            {formatDateTime(created)}
                        </Column>
                        <Column size={2}>
                            {campaignName.replace(/_/g, ' ')}
                        </Column>
                        <Column size={2}>
                            <RatingComponent total={10} score={score}/>
                        </Column>
                        <Column size={6}>
                            {comment}
                        </Column>
                    </Row>
                )
            })}

        </React.Fragment>
    )
}


CustomerFeedback.propTypes = {
    feedbackList: PropTypes.array,
}

export default CustomerFeedback



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/CustomerFeedback.js